// TODO: Move me to the repo pattern
// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.services").
factory("role", function roleFactory($http) {
	"use strict";

	return {
		query: function query(queryParams) {
			var requestConfig = {
				url: "/node/role/query/",
				method: "GET",
				params: queryParams,
			};

			return $http(requestConfig).then(function success(response) {
				return response.data;
			});
		},
	};
});
